import { useEffect, useMemo, useRef } from 'react'

import { useWallet, Wallet } from '@solana/wallet-adapter-react'

import { solanaWallet, WalletInfo } from '@/config'
import useDebounce from '@/hooks/use-debounce'
import { StoredWalletData, WALLET_ICONS, WALLET_PHANTOM, WalletStorage, WalletType } from '@/utils'
import { NotInstallWallet } from '@/wallets'

// call at once place
export default function useSolanaWallet() {
  const data = useWallet()
  // this is not a best practice, but with the current btc wallet, this is the best way for now if we dont want to change btc wallet interface as well
  window.solanaContext = data
}

const defaultWallet: WalletInfo = {
  icon: WALLET_ICONS[WALLET_PHANTOM],
  name: 'Phantom',
  key: WALLET_PHANTOM,
  isDetected: () => false,
  priority: 0,
  wallet: new NotInstallWallet({ name: WALLET_PHANTOM, installUrl: 'https://phantom.com/' }),
  type: WalletType.WALLET_TYPE_BROWSER_WALLET,
}
export const useSolanaAdapters = () => {
  const { wallets } = useWallet()

  return useMemo(() => {
    if (!wallets?.length) {
      return { adapters: [defaultWallet] }
    }
    const formatWallets: WalletInfo[] = wallets.map((e) => {
      return {
        adapter: e,
        icon: e.adapter.icon,
        name: e.adapter.name,
        key: e.adapter.name,
        wallet: solanaWallet,
        isDetected: () => e.readyState === 'Installed',
        priority: 0,
        type: WalletType.WALLET_TYPE_BROWSER_WALLET,
      }
    })
    return { adapters: formatWallets }
  }, [wallets])
}

export const useReconnectSol = (
  onConnected: (data: { adapter: Wallet; network: string; data: StoredWalletData }) => void
) => {
  const { wallet, connecting, connected } = useWallet()
  const storeInfo = useRef(WalletStorage.getSaveSolWallet())

  const isInit = useRef(false)
  useEffect(() => {
    if (isInit.current || !(connected && wallet) || !storeInfo.current) return
    const [network, data] = storeInfo.current
    onConnected({ adapter: wallet, network, data })
    console.debug('reconnect sol', wallet)
    isInit.current = true // call once
  }, [connected, wallet])

  return useDebounce(connecting, 300)
}
